import Cookies from "universal-cookie";
import { LOGIN, LOGOUT } from "./actions";
const cookies = new Cookies();

const defaultObj = {
  isAuthenticated:
    cookies.get("authToken") && cookies.get("authToken") !== undefined
      ? cookies.get("authToken")
      : null,
  authToken:
    cookies.get("authToken") !== undefined ? cookies.get("authToken") : null,
  user: cookies.get("user") !== undefined ? cookies.get("user") : null,
};

export const UserReducers = (state = defaultObj, action) => {
  switch (action.type) {
    case LOGIN:
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 30);

      const secretToken = action.payload.accessToken;
      cookies.set("authToken", secretToken, { path: "/", expires: expireDate });
      cookies.set("user", action.payload, { path: "/", expires: expireDate });
      return {
        authToken: secretToken,
        isAuthenticated: true,
        user: action.payload,
      };
    case LOGOUT:
      cookies.remove("authToken", { path: "/" });
      cookies.remove("user", { path: "/" });
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};
